module.exports = __webpack_public_path__ + "static/img/x-level-5.e4c1daa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/x-level-5.svg
// module id = wE7o
// module chunks = 66